<template>
  <list
    row-key="ProcessId"
    ref="list"
    :page="page"
    :query-params="params"
    :show-checkbox="showCheckbox"
    :show-query="showQuery"
    :get-data-func="api.list"
  >
    <template slot="toolbar-right">
      <slot name="toolbar-right"></slot>
    </template>
    <template slot="query">
      <el-form-item label="流程名称">
        <el-input v-model="params.ProcessName" placeholder="请输入流程名称" clearable />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="params.Status" clearable>
          <el-option :value="1" label="启用"></el-option>
          <el-option :value="0" label="停用"></el-option>
        </el-select>
      </el-form-item>
    </template>
    <template slot="table">
      <!-- <el-table-column prop="流程类别" label="流程类别" /> -->
      <el-table-column prop="ProcessName" label="流程名称" />
      <el-table-column prop="Description" label="流程描述" />
      <!-- <el-table-column prop="Capacity" label="异常时处理人员" /> -->
      <el-table-column prop="Sort" label="序号" align="center" width="60px" />
      <el-table-column prop="Status" label="状态" align="center" width="60px">
        <template slot-scope="{row}">
          <span v-if="row.Status==0">停用</span>
          <span v-if="row.Status==1">启用</span>
        </template>
      </el-table-column>
      <slot name="column"></slot>
    </template>
  </list>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/wf/process").default,
      params: {
        ProcessName: "",
        Status: null,
        IsTemplate: false,
      },
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>